import { Component, OnInit } from '@angular/core';

import { Docorga } from '@docorga-v1/docorga-common';

import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'dc-layout-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less'],
})
export class HeaderComponent implements OnInit {
  constructor(private readonly AuthService: AuthService) {}

  currentUser: Docorga.interfaces.structureMember.IStructureMemberPublicJson;
  isAuthenticated: boolean;
  isCompleted: boolean;

  ngOnInit() {
    this.AuthService.currentUser.subscribe(
      (userData: Docorga.interfaces.structureMember.IStructureMemberPublicJson) => {
        this.currentUser = userData;
      }
    );

    this.AuthService.isCompleted.subscribe((isCompleted) => this.isCompleted = isCompleted);

    this.AuthService.isAuthenticated.subscribe((isAuthenticated) => this.isAuthenticated = isAuthenticated);
  }
  
  register() {
   this.AuthService.register();
  }


  logout() {
   this.AuthService.logout();
  }
}
